module.exports = __webpack_public_path__ + "img/44-green.87459140.svg";